// extracted by mini-css-extract-plugin
export default {"kinescopeLeftovers":"style_kinescopeLeftovers__rPHAe","kinescopeCapacity":"style_kinescopeCapacity__diLja","kinescopeText":"style_kinescopeText__I-wyJ"};